import { render, staticRenderFns } from "./RestaurantInfo.vue?vue&type=template&id=3300a45a&"
import script from "./RestaurantInfo.vue?vue&type=script&lang=js&"
export * from "./RestaurantInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports